<template>
  <div id="requiredList">
    <div :class="fixed?'fixed':''">
      <div class="clear topMenu container">
        <div class="clear-item" :class="classId==1?'active':''" @click="classId=1">耗材器具</div>
        <div class="clear-item" :class="classId==2?'active':''" @click="classId=2">实验办公</div>
        <div class="clear-item" :class="classId==3?'active':''" @click="classId=3">试剂生化</div>
        <div class="clear-item" :class="classId==4?'active':''" @click="classId=4">抗体WB</div>
        <div class="clear-item" :class="classId==5?'active':''" @click="classId=5">设备仪器</div>
        <div class="clear-item" :class="classId==6?'active':''" @click="classId=6">实验动物</div>
        <div class="clear-item" :class="classId==7?'active':''" @click="classId=7">技术服务</div>
        <div class="clear-item" :class="classId==8?'active':''" @click="classId=8">洁净装置</div>
        <div class="clear-item" :class="classId==9?'active':''" @click="classId=9">生物软件</div>
        <div class="clear-item" :class="classId==10?'active':''" @click="classId=10">书城医学</div>
        <div class="clear-item" :class="classId==11?'active':''" @click="classId=11">生物制药</div>
      </div>
    </div>
    <div class="container">
      <div style="margin-top:10px">
        <el-row :gutter="20">
          <el-col :span="6" v-for="(item,index) of data" :key="index">
            <div class="p-item">
              <div style="margin-bottom:5px;">
                <router-link :to="'/product/'+item.id">
                  <img
                    :src="serve +item.images"
                    style="width:265px;height:268px;"
                  >
                </router-link>
              </div>
              <router-link :to="'/product/'+item.id">
                <div style="margin-bottom:10px;height:33px;overflow:hidden">{{item.title}}</div>
              </router-link>
              <div class="lv0Text">
                <span style="margin-right:2px">
                  <i class="far fa-thumbs-up"></i>
                </span>
                {{item.collect_number}}人点赞
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      serve: this.$store.state.serve,

      //
      data: {},
      classId: 1,
      fixed: false
    };
  },
  watch: {
    classId: "loadData"
  },
  created() {
    //
    this.loadData();
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    //
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 295) {
        this.fixed = true;
      } else {
        this.fixed = false;
      }
    },
    loadData() {
      this.axios
        .get(this.serve + "/required", {
          params: {
            class: this.classId
          }
        })
        .then(res => {
          this.data = res.data;
        });
    }
  }
};
</script>
<style lang="scss">
#requiredList {
  background-image: url("https://www.bioflin.com:83/images/bg1.png");
  background-size: 100% auto;
  background-repeat: no-repeat;
  background-position: top;
  min-width: 1200px;
  .fixed {
    position: fixed;
    top: 0;
    z-index: 99;
    width: 100%;
  }
  .p-item {
    background-color: #fff;
    margin-bottom: 10px;
    padding: 10px;
  }
  padding: 100px 0 50px 0;
  .topMenu {
    background-color: #fff;
    padding: 30px 0 10px 0;
    .clear-item {
      margin: 0 26px;
      cursor: pointer;
    }
    .clear-item.active {
      border-bottom: 2px solid #e2211c;
      padding-bottom: 10px;
    }
  }
}
</style>